
import React, { Component, Fragment } from 'react';
import '../global';
import FeaturedBookCover from './featured-book-cover';
import BookSection from './book-section';
class BookStoreContent extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			ready: false, showFilters: false, isMobile: false
		};
        
        this.bookstore_desc = getBookStoreObj().bookstore_description;
        this.bookstore_login_embed = getBookStoreObj().bookstore_login_embed;
        this.featured_books = getBookStoreObj().featured_books;
        this.books_with_book_sections = getBookStoreObj().books_with_book_sections;
        this.book_sections = getBookStoreObj().book_sections;
	}

	render() {


		return (
		<div>
        <section id="book-catalog-anchors"></section>
        <div class="bookstore-desc">
            <div dangerouslySetInnerHTML={{__html: this.bookstore_desc}} />
         </div>
            <div id="books-ondemand-login-block" class="login-block-common">
                <p id="books-ondemand-login-text">You must be logged in to add items to your Shopping Cart.</p>
                <div dangerouslySetInnerHTML={{__html: this.bookstore_login_embed}} />
            </div>
            <section class="section-title">
                <h2 class="section-title__heading-gold"><span>Featured</span></h2>
                <div class="section-title__divider"></div>
                <div class="bookstore-featured">
                    {this.featured_books.map((book, index) => (
                        <FeaturedBookCover key={index} book={book} />
                    ))}
                </div>
            </section>
            <button id="mobile-sidebar-options">Categories</button>
            <div id="bookstore-catalog-view">
			<div id="catalog-content">
                {this.book_sections.map((section, index) => {
                    const sectionData = this.books_with_book_sections[section.slug];
                    return sectionData ? (
                        <BookSection key={index} section_slug={section.slug} section={sectionData} section_name={section.name} />
                    ) : null;
                })}
                </div>
            </div>

        </div>
		);
	}
}


export default BookStoreContent; // Wrap with withRouter
